import { Routes } from '@angular/router';
import { WorkflowsDetailComponent } from './pages/workflows-detail/workflows-detail.component';
import { WorkflowsFormComponent } from './pages/workflows-form/workflows-form.component';
import { WorkflowsListComponent } from './pages/workflows-list/workflows-list.component';
import { RoleGuard } from '../core/guards/auth.guard';
import { Permission } from '../core/models/role-permissions.models';

export default [
	{
		path: '',
		loadComponent: () => WorkflowsListComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.WORKFLOW_VIEW],
			comeback: 'panel',
		},
	},
	{
		path: 'create',
		loadComponent: () => WorkflowsFormComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.WORKFLOW_CREATE],
			comeback: 'workflows',
		},
	},
	{
		path: 'edit/:id',
		loadComponent: () => WorkflowsFormComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.WORKFLOW_UPDATE],
			comeback: 'workflows',
		},
	},
	{
		path: 'detail/:id',
		loadComponent: () => WorkflowsDetailComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.WORKFLOW_VIEW],
			comeback: 'workflows',
		},
	},
] as Routes;
